// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
// import Vuex from 'vuex'
// import MintUI from 'mint-ui'
// import request from './http/request'
// import 'mint-ui/lib/style.css'
import animated from 'animate.css'
import 'babel-polyfill'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location)
}

//进度条
// import NProgress from 'nprogress'
// import 'nprogress/nprogress.css'
// Vue.use(MintUI)
// Vue.use(Vuex);
Vue.use(animated)

// const { post, get } = request
// Vue.prototype.$post = post
// Vue.prototype.$get = get
// Vue.prototype.$axios = axios
// axios.defaults.withCredentials = true;

//进度条
// NProgress.configure({     
//     easing: 'ease',  // 动画方式    
//     speed: 500,  // 递增进度条的速度    
//     showSpinner: false, // 是否显示加载ico    
//     trickleSpeed: 200, // 自动递增间隔    
//     minimum: 0.3 // 初始化时的最小百分比
// })
Vue.config.productionTip = false
//当路由进入前
router.beforeEach((to, from, next) => {
  // 每次切换页面时，调用进度条
  //    NProgress.start();
  next();
});
//当路由进入后：关闭进度条
router.afterEach(() => {

  // 在即将进入新的页面组件前，关闭掉进度条
  //    NProgress.done()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js